




















































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import indicador_frecuencias from '@/mixins/axios/indicador_frecuencias'

//@ts-ignore
import indicador_mes_frecuencias from '@/mixins/axios/indicador_mes_frecuencias'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import FrecuenciaHeader from '@/components/headersSelect/frecuencia'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    FrecuenciaHeader,
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
 

        columnasd:[
           
          /*  {
                tag:'select',
                data:'select',
                active:false
            },*/
           
            {
                tag:'frecuencia',
                data:'frecuencia',
                active:true
            }, 
            {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
            ],



indicador_mes_frecuencias:false,


        id:null as any,

      frecuencia:'' as any,

         
         
              indicador_frecuencias:[] as any,
              indicador_mes_frecuencias:[] as any,
        
      
    }
  },
     mixins: [indicador_frecuencias],
     validations: {
    
           frecuencia: {
      required,
    },
   
   
  },





  methods:{
            clearstate(){
this.$store.commit('SETIMF',null);
 this.$router.push('/mun/general/indicadores/frecuencias')
        },
      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_INDICADOR_FRECUENCIA(row).then(response => {

                    if (response != null) {

 this.indicador_frecuencias=this.indicador_frecuencias.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },
     select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETIMF',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/general/indicadores/frecuencias/meses')
//this.getDataDepartamentos();
     
     },
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
      
                 this.frecuencia=null;

        

      },
      addRow(){
          this.limpiar();
 $('#ac_modal_indicador_frec').modal('show')
      },
seteditar(row){

 this.id=row.id;
 this.frecuencia=row.frecuencia;

         
                            
          
 $('#ac_modal_indicador_frec').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_INDICADOR_FRECUENCIA(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.indicador_frecuencias.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Indicador Frecuencias, refresque la pagina");

                    }    $("#ac_modal_indicador_frec").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_INDICADOR_FRECUENCIA(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Indicardo de frecuencia modificado correctamente.");
  this.indicador_frecuencias=this.indicador_frecuencias.filter(item => item.id !== dat.id);
 this.indicador_frecuencias.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Indicador Frecuencias, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
 
           frecuencia:this.frecuencia, 
            idmunicipio:this.$store.state.user.usuario.id_municipio,

}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_INDICADOR_FRECUENCIA(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_frecuencias=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
async getDataMesFrecuencia() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
frecuencia:this.frecuancia_sel.id,
/*mes:this.frecuancia_sel.id,
abreviacion:this.frecuancia_sel.id,
num_mes:this.frecuancia_sel.id,*/
idmunicipio:this.$store.state.user.usuario.id_municipio




};

let data= await this.GET_INDICADOR_MES_FRECUENCIA(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        

this.mes=response;
this.abreviacion=response;
this.num_mes=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
}

 
  },
  mounted(){
      this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

